import {createContext, useContext, useState} from 'react';

const AuditCalcContext = createContext({
  sectionScore: {
    finalScore: null,
    totalScore: null,
    id: '',
  },
  auditScore: {
    finalScore: null,
    totalScore: null,
  },
  setSectionScore: val => val,
  timeElapsed: null,
  setTimeElapsed: val => val,
  setAuditScore: val => val,
});

const useAuditCalc = () => {
  const context = useContext(AuditCalcContext);
  if (context === undefined) {
    throw new Error('useAuditData must be used within a AuditDataProvider');
  }

  return context;
};

const AuditCalcProvider = ({...props}) => {
  const [sectionScore, setSectionScore] = useState();
  const [auditScore, setAuditScore] = useState();
  const [timeElapsed, setTimeElapsed] = useState();

  return (
    <AuditCalcContext.Provider
      value={{
        sectionScore,
        setSectionScore,
        timeElapsed,
        setTimeElapsed,
        auditScore,
        setAuditScore,
      }}
      {...props}
    />

  );
};

export { useAuditCalc, AuditCalcProvider };
